import styled from 'styled-components'

export const TextWrapper = styled.div`
  margin-left: 12px;
  overflow: hidden;
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

export const TitleText = styled.span`
  overflow-wrap: break-word;
`
